/**
 * Renders a read-only view of the attributes of a map service as well as an interface for modifying permissions of the service.
 * ## Fields
 * Name | Description
 * --- | ---
 * model | The `MapService` model associated with the view.
 * @module app/views/admin/mapServices/Details
 */
import Backbone from "backbone";
import _ from "underscore";
import DetailView from "core/views/DetailView";
import PermissionView from "app/views/admin/permissions/Editor";
import GroupCollection from "app/models/GroupCollection";
import LayerView from "app/views/admin/mapServices/Layers";
import Field from "core/models/Field";
import ValueCollections from "app/models/ValueCollections";
import viewTemplate from "views/admin/mapServices/Details";
import ErrorUtils from "app/utils/ErrorUtils";
import Helper from "app/ejs";
export default Backbone.View.extend({
  /**
   * Initializes the view.
   * @param  {object} options The options hash.
   * @param {MapService} options.model The model to display.
   * @param {Array} options.fields The array of `Field` models indicating the map service fields to display.
   */
  initialize: function (options) {
    this.options = _.defaults({}, options, {
      model: null,
    });

    this.model = this.options.model;
  },

  template: Helper.template(viewTemplate),
  className: "map-service-details",

  delegateEvents: function () {
    Backbone.View.prototype.delegateEvents.apply(this, arguments);
    this.trigger("delegate-events");
  },

  render: function () {
    var self = this;

    this.$el.html(this.template(this.options));
    var detailView = new DetailView({
      model: this.model,
      fields: this.options.fields,
    });

    detailView.render();
    detailView.$el.appendTo(
      this.$(".details-tab .slider-outer .slider-content")
    );

    this.on("delegate-events", function () {
      //detailView.delegateEvents();
      detailView.render();
    });

    var groups = new GroupCollection([]);

    groups.fetch({
      success: function () {
        var actions;

        if (self.model.get("external")) {
          actions = {
            read: "View the service",
            update: "Update properties of the service, including security.",
          };
        } else {
          actions = {
            read: "View the service.",
            update: "Update properties of the service, including security.",
            delete: "Delete the service.",
            "form:read": "View objects and properties of any layer.",
            "form:delete": "Delete any layer.",
            "form:update":
              "Update properties of any layer, including security.",
            "form:create": "Add a layer to the service.",
            "form:add": "Add objects to any layer.",
            "form:remove": "Remove objects from any layer.",
            "form:modify": "Modify objects on any layer.",
          };
        }

        var permissionView = new PermissionView({
          groups: groups.models,
          type: {
            MapService: self.model.id,
          },
          actions: actions,
        });

        permissionView.render();
        permissionView.$el.appendTo(
          self.$(".permissions-tab .slider-outer .slider-content")
        );

        self.on("delegate-events", function () {
          //permissionView.delegateEvents();
          permissionView.render();
        });
      },
      error: ErrorUtils.apiHandler({
        activity: "loading the groups",
      }),
    });

    if (!this.model.get("external")) {
      var layerView = new LayerView({
        layerCollection: this.model.get("objectLayers"),
        model: this.model,
        fields: [
          new Field({
            id: "Name",
            name: "Name",
            label: "Layer Name",
            sortable: true,
            filterable: true,
            editor: "text",
          }),
          new Field({
            id: "updatedAt",
            name: "updatedAt",
            label: "Updated At",
            editor: "date",
            editable: false,
            viewOptions: {
              type: "fromnow",
            },
            sortable: true,
          }),
          new Field({
            id: "createdAt",
            name: "createdAt",
            label: "Created At",
            editor: "date",
            editable: false,
            viewOptions: {
              type: "fromnow",
            },
            sortable: true,
          }),
          new Field({
            id: "Creator",
            name: "Creator",
            label: "Created By",
            editable: false,
            valueSource: ValueCollections.User,
            sortable: true,
          }),

          new Field({
            id: "objectCount",
            name: "objectCount",
            label: "Object Count",
            editor: "text",
            editable: false,
            sortable: true,
          }),
        ],
      });

      layerView.render();
      layerView.$el.appendTo(
        this.$(".layers-tab .slider-outer .slider-content")
      );

      self.on("delegate-events", function () {
        //layerView.delegateEvents();
        layerView.render();
      });
    }
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/admin/mapServices/Details.js
// module id = 925
// module chunks = 1